

//系统标识
export const CLIENT_APP_CODE = "portal";

export const DEFAULT_PAGE_SIZE = 10;
export const DEFAULT_FIRST_PAGE_NUM = 1;
export const DEFAULT_REQUEST_TIMEOUT = 10000;

enum baseRequestUrlEnum {
    "DEV" = "https://api.peijian88.cn",
    "STAGE" = "https://api.beiben88.com",
    "TEST" = "https://test-api-2.laoniuche.cn",
    "PROD" = "https://tam-api.yunhaogroup.com"
}


//API请求环境
const baseRequestUrl = {
    "DEV": `https://api.peijian88.cn/portal`,
    "TEST": `https://test-api-2.laoniuche.cn/portal`,
    "PROD": `https://tam-api.yunhaogroup.com/portal`,
    "STAGE": `https://api.beiben88.com/portal`,
}

export const baseChatGPTUrl = {
    "DEV": `https://chat.laoniuche.cn/#/chat`,
    "TEST": `https://chat.laoniuche.cn/#/chat`,
    "PROD": `https://chat.yunhaogroup.com/#/chat`,
    "STAGE": `https://chat.laoniuche.cn/#/chat`,
}

//根据环境变量自动获取图片查看地址
export const getBaseImgLookUrl = (md5: string) => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    //自动选择环境
    return `${baseRequestUrlEnum[REACT_APP_ENV ?? "DEV"]}/fsrv/fetch/${md5}?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseImgUploadUrl = () => {
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    //自动选择环境
    return `${baseRequestUrlEnum[REACT_APP_ENV ?? "DEV"]}/fsrv/upload_file?Authorization=${getToken()}`
}

//根据环境变量自动获取图片上传地址
export const getBaseUploadData = () => {
    return {
        appCode: CLIENT_APP_CODE,
        fileMode: 0,
    }
}




// const baseFileRequestUrl = "https://file-server.laoniuche.cn/file";
// /**
//  * 上传文件路径
//  */
// export const uploadFileUrl = `${baseFileRequestUrl}/uploadFile`;
// /**
//  * 获取文件服务器文件
//  * @param id 
//  * @returns 
//  */
// export const loadFileUrl = (id: string) => `${baseFileRequestUrl}/fetch?id=${id}`;


//根据环境变量自动获取请求地址
export const getBaseRequestUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    return baseRequestUrl[REACT_APP_ENV ?? "DEV"]
};

//根据环境变量自动获取请求地址
export const getChatGPTUrl = () => {
    //自动选择环境
    //....
    const REACT_APP_ENV = process.env.REACT_APP_ENV as "DEV" | "TEST" | "PROD" | "STAGE";
    return baseChatGPTUrl[REACT_APP_ENV ?? "DEV"]
};

//服务器自定义错误码serve 
export const INTERNAL_SERVER_ERROR_CODE = 500;
export const INTERNAL_SERVER_LOGON_FAILURE_CODE = 401;
//token存储KEY值
export const TOKEN_KEY = "token";
export const IP_KEY = "ip";
//获取token
export const getToken = () => {
    return sessionStorage.getItem(TOKEN_KEY) ?? "default-token-str"
};
//存储token
export const setToken = (token: string) => {
    sessionStorage.setItem(TOKEN_KEY, token)
};
//清除token
export const clearToken = () => {
    sessionStorage.removeItem(TOKEN_KEY)
};
//获取IP
export const getIP = () => {
    return sessionStorage.getItem(IP_KEY) ?? ""
};
//存储IP
export const setIP = (ip: string) => {
    sessionStorage.setItem(IP_KEY, ip)
};
//清除IP
export const clearIP = () => {
    sessionStorage.removeItem(IP_KEY)
};

